interface EmptyStateProps {
  icon: string;
  text: string;
  hint?: string;
}

export function EmptyState({ icon, text, hint }: EmptyStateProps) {
  return (
    <div className="empty-state">
      <span className="empty-state__icon">{icon}</span>
      <p className="empty-state__text">{text}</p>
      {hint && <p className="empty-state__hint">{hint}</p>}
    </div>
  );
}
